<template>
  <svg width="16" height="16" viewBox="0 0 16 16">
    <path d="M0.888963 8.8888C0.644521 8.64436 0.5223 8.34791 0.522299 7.99947C0.5223 7.65103 0.644521 7.35489 0.888963 7.11104L7.11112 0.888881C7.35556 0.644439 7.652 0.522218 8.00044 0.522218C8.34889 0.522218 8.64503 0.644439 8.88888 0.888881L15.111 7.11104C15.3555 7.35548 15.4777 7.65192 15.4777 8.00036C15.4777 8.3488 15.3555 8.64495 15.111 8.8888L8.88888 15.111C8.64444 15.3554 8.348 15.4776 7.99956 15.4776C7.65111 15.4776 7.35497 15.3554 7.11112 15.111L0.888963 8.8888ZM1.77784 7.99992L8 14.2221L14.2222 7.99992L8 1.77776L1.77784 7.99992Z" fill="#FCFCFC"/>
  </svg>
</template>

<script>
export default {
  name: 'decision-icon'
}
</script>

<style scoped>

path {
  stroke-width: 0 !important;
  fill: currentColor;
}

</style>
